import {
    EnvironmentProviders,
    Provider,
    inject,
    provideEnvironmentInitializer,
} from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';

/** Creates AuthService at start-up. Its interceptors are registered with the HTTP client in app.config.ts. */
export const provideAuth = (): Array<Provider | EnvironmentProviders> => {
    return [provideEnvironmentInitializer(() => inject(AuthService))];
};
